import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

import BVContainerLoader from '../../../../../../../../../common/components/BVContainerLoader/bv-container-loader';
import BVComboBox from '../../../../../../../../../common/components/BVControls/BVComboBox/bv-combo-box';
import BVInput from '../../../../../../../../../common/components/BVControls/BVInput/bv-input';
import BVTextArea from '../../../../../../../../../common/components/BVControls/BVTextArea/bv-text-area';
import { IBVModal } from './bv-modal';

import { useAcceptanceBookedForSales } from '../../../../../../../hooks/useAcceptanceBookedForSales';
import { useCustomers } from '../../../../../../../hooks/useCustomers';
import {
	ConfirmFormValidator,
	IConfirmForm,
	useConfirmForm,
} from './hooks/useConfirmForm';

import {
	BookedForSalesOrderReason,
	BookedForSalesProduct,
	CustomerFacility,
} from '../../../../../../../../../api-client';

import BVSwitch from '../../../../../../../../../common/components/BVControls/BVSwitch/bv-switch';
import './bv-confirm-modal.scss';

interface IBVConfirmModal extends IBVModal {
	bookedForSalesProduct: BookedForSalesProduct;
	orderReasons: BookedForSalesOrderReason[];
	onAccept: () => void;
}

const BVConfirmModal: React.FC<IBVConfirmModal> = ({
	title,
	visible,
	onCancel,
	onOk,
	onAccept,
	bookedForSalesProduct,
	facilities,
}) => {
	const [formErrors, setFormErrors] = useState<any>({});

	const { handleInitialize, handleChange, formValues } = useConfirmForm();
	const { handleConfirmModal, acceptBookedForSalesLoading } =
		useAcceptanceBookedForSales();
	const { handleOrderReasons, orderReasons } = useCustomers();

	const handleCancel = () => {
		onCancel();
	};

	useEffect(() => {
		handleOrderReasons();
	}, []);

	useEffect(() => {
		if (visible) {
			let formInitializer: IConfirmForm = {
				shipTo: '',
				poNumber: '',
				note: '',
				reasonWhy: '',
				orderReasons: '',
				sendToSap:
					bookedForSalesProduct.type !== 'W',
			};
			handleInitialize(formInitializer);

			setFormErrors({});
		}
	}, [visible]);

	const handleConfirm = () => {
		const acceptBookedForSales = {
			customerFacilityId: parseInt(formValues.shipTo || ''),
			poNumber: formValues.poNumber || '',
			orderReasonCode: formValues.orderReasons || '',
			note: formValues.note || '',
			sendToSap: formValues.sendToSap,
		};

		if (bookedForSalesProduct.id) {
			let validationResult = {};
			if (bookedForSalesProduct.type === 'W') {
				validationResult = ConfirmFormValidator.validateForm(formValues);
				setFormErrors(validationResult);
			}

			if (Object.keys(validationResult).length === 0) {
				handleConfirmModal(
					bookedForSalesProduct.id,
					acceptBookedForSales,
					onOk,
					onAccept,
				);
			}
		}
	};

	const handleShipToChange = (value: string) => {
		handleChange('shipTo', value);
	};

	const handleOrderReasonsChange = (value: string) => {
		handleChange('orderReasons', value);
	};

	const handlePoNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleChange('poNumber', event.target.value);
	};

	const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		handleChange('note', event.target.value);
	};

/* 	const handleSendToSapChange = (checked: boolean, event: MouseEvent) => {
		handleChange('sendToSap', checked);
	}; */

	return (
		<Modal
			title={title}
			visible={visible}
			footer={null}
			onOk={onOk}
			onCancel={onCancel}
			confirmLoading={acceptBookedForSalesLoading}
		>
			{bookedForSalesProduct && bookedForSalesProduct.type === 'W' ? (
				<React.Fragment>
					<div className="form-group">
						<BVComboBox
							label={'Ship To:'}
							required
							data={(facilities || [])
								.map((facility: CustomerFacility) => ({
									label: facility.address,
									value: facility.id,
								}))}
							errorMessage={formErrors.shipTo}
							properties={{
								value: formValues.shipTo,
								onChange: handleShipToChange,
							}}
						/>
						<BVComboBox
							label={'Order Reasons:'}
							required
							data={(orderReasons || []).map(
								(orderReasons: BookedForSalesOrderReason) => ({
									label: orderReasons.description,
									value: orderReasons.code,
								}),
							)}
							errorMessage={formErrors.orderReasons}
							properties={{
								value: formValues.orderReasons,
								onChange: handleOrderReasonsChange,
							}}
						/>
						<BVInput
							label={'PO Number:'}
							errorMessage={formErrors.poNumber}
							required
							properties={{
								placeholder: 'PO Number...',
								value: formValues.poNumber,
								onChange: handlePoNumberChange,
								maxLength: 35,
							}}
						/>
					</div>
				</React.Fragment>
			) : null}

			<div className="form-group">
				<BVTextArea
					label={'Note:'}
					properties={{
						placeholder: 'Enter Notes...',
						value: formValues.note,
						onChange: handleNoteChange,
					}}
				/>
			</div>

			<div className="confirm-buttons">
				<Button
					type="primary"
					size={'large'}
					onClick={handleCancel}
					style={{
						color: '#000000',
						borderColor: '#999999',
						backgroundColor: '#FFFFFF',
						paddingInline: '25px',
					}}
				>
					{'Undo'}
				</Button>

				<Button
					type="primary"
					size={'large'}
					onClick={handleConfirm}
					disabled={acceptBookedForSalesLoading}
					style={{
						color: '#fff',
						borderColor: '#999999',
						backgroundColor: '#006400',
						marginLeft: '20px',
						paddingInline: '25px',
					}}
				>
					{'Confirm Order'}
				</Button>
			</div>
			<BVContainerLoader loading={acceptBookedForSalesLoading} />
		</Modal>
	);
};

export default BVConfirmModal;
